import { render, staticRenderFns } from "./SystemSettings.vue?vue&type=template&id=e704c674&scoped=true&"
import script from "./SystemSettings.vue?vue&type=script&lang=ts&"
export * from "./SystemSettings.vue?vue&type=script&lang=ts&"
import style0 from "./SystemSettings.vue?vue&type=style&index=0&id=e704c674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e704c674",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VProgressCircular,VRow,VTextField})
